export const localeForCurrency = (currency: string): string => {
	switch (currency) {
		case 'EUR':
			return 'de-DE'

		case 'GBP':
			return 'gb-GB'

		case 'USD':
			return 'en-US'

		default:
			return 'en-US'
	}
}

export const formatPrice = (
	price: number,
	currency: string,
	minFracDigits = 2,
	maxFracDigits = 4,
	currencyDisplay = true,
): string => {
	const formatter = new Intl.NumberFormat(localeForCurrency(currency), {
		style: currencyDisplay ? 'currency' : 'decimal',
		currency: currency || 'USD',
		minimumFractionDigits: minFracDigits,
		maximumFractionDigits: maxFracDigits,
	})

	return price >= 0.0 ? formatter.format(price) : `(${formatter.format(Math.abs(price))})`
}

export const formatNumber = (
	number: number,
	decimals = 2,
	maxDecimals = 2,
	format = 'de-DE',
): string => {
	const formatter = new Intl.NumberFormat(format, {
		minimumFractionDigits: decimals,
		maximumFractionDigits: maxDecimals,
	})

	return formatter.format(number)
}

export const formatLargeCurrency = (
	number: number,
	currency = 'USD',
	billion = 'Bn',
	million = 'M',
): string => {
	let num = number

	const isNegative = num < 0
	let string = isNegative ? '(' : ''
	const currencyPrice = formatPrice(0, currency, 0, 0)
	num = Math.abs(num)

	if (num > 100000000000) {
		string += currencyPrice.replace(
			'0',
			formatNumber(num / 1000000000, 0, 0, localeForCurrency(currency)) + billion,
		)
	} else if (num > 1000000000) {
		string += currencyPrice.replace(
			'0',
			formatNumber(num / 1000000000, 0, 2, localeForCurrency(currency)) + billion,
		)
	} else if (num > 1000000) {
		string += currencyPrice.replace(
			'0',
			formatNumber(num / 1000000, 0, 3, localeForCurrency(currency)) + million,
		)
	} else {
		string += currencyPrice.replace(
			'0',
			formatNumber(num, 0, 0, localeForCurrency(currency)),
		)
	}

	return string + (isNegative ? ')' : '')
}
